"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    addWeeks: function() {
        return _addWeeks.default;
    },
    dateFromDay: function() {
        return dateFromDay;
    },
    dayNames: function() {
        return dayNames;
    },
    differenceInDays: function() {
        return _differenceInDays.default;
    },
    formatDate: function() {
        return formatDate;
    },
    gameSettingsFromDate: function() {
        return gameSettingsFromDate;
    },
    getDateOfISOWeek: function() {
        return getDateOfISOWeek;
    },
    isSameWeek: function() {
        return _isSameWeek.default;
    },
    isWithinStartEndRange: function() {
        return isWithinStartEndRange;
    },
    monthNames: function() {
        return monthNames;
    },
    renderDate: function() {
        return renderDate;
    },
    shortDayNames: function() {
        return shortDayNames;
    },
    shortMonthNames: function() {
        return shortMonthNames;
    },
    subWeeks: function() {
        return _subWeeks.default;
    }
});
const _format = /*#__PURE__*/ _interop_require_default(require("date-fns/format"));
const _isSameMonth = /*#__PURE__*/ _interop_require_default(require("date-fns/isSameMonth"));
const _isSameYear = /*#__PURE__*/ _interop_require_default(require("date-fns/isSameYear"));
const _startOfYear = /*#__PURE__*/ _interop_require_default(require("date-fns/startOfYear"));
const _getDay = /*#__PURE__*/ _interop_require_default(require("date-fns/getDay"));
const _addDays = /*#__PURE__*/ _interop_require_default(require("date-fns/addDays"));
const _addWeeks = /*#__PURE__*/ _interop_require_default(require("date-fns/addWeeks"));
const _subWeeks = /*#__PURE__*/ _interop_require_default(require("date-fns/subWeeks"));
const _getDayOfYear = /*#__PURE__*/ _interop_require_default(require("date-fns/getDayOfYear"));
const _getYear = /*#__PURE__*/ _interop_require_default(require("date-fns/getYear"));
const _isSameWeek = /*#__PURE__*/ _interop_require_default(require("date-fns/isSameWeek"));
const _differenceInDays = /*#__PURE__*/ _interop_require_default(require("date-fns/differenceInDays"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const renderDate = _format.default;
const dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const shortDayNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const shortMonthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec"
];
function dateFromDay(year, day) {
    const date = new Date(year, 0) // initialize a date in `year-01-01`
    ;
    return new Date(date.setDate(day)) // add the number of days
    ;
}
function gameSettingsFromDate(oldDate) {
    const date = new Date(oldDate);
    const dayOfYear = (0, _getDayOfYear.default)(date);
    const year = (0, _getYear.default)(date);
    return {
        dayOfYear,
        year
    };
}
function getOrdinalNum(n) {
    return n + (n > 0 ? [
        "th",
        "st",
        "nd",
        "rd"
    ][n > 3 && n < 21 || n % 10 > 3 ? 0 : n % 10] : "");
}
function formatDate(date) {
    const dateRef = new Date(date);
    const dateN = dateRef.getDate();
    const day = shortDayNames[dateRef.getDay()];
    const month = shortMonthNames[dateRef.getMonth()];
    return `${day} ${getOrdinalNum(dateN)} ${month}`;
}
function getDateOfISOWeek(w = 1, y = (()=>{
    var _this;
    return (_this = new Date()) === null || _this === void 0 ? void 0 : _this.getFullYear();
})(), d = 0) {
    const year = new Date(y, 1, 1, 1, 1, 1);
    const startDayOfYear = (0, _startOfYear.default)(year);
    const diff = d - (0, _getDay.default)(startDayOfYear);
    const firstAppearanceOfYear = (0, _addDays.default)(startDayOfYear, diff < 0 ? 7 + diff : diff);
    return (0, _addWeeks.default)(firstAppearanceOfYear, w - 1);
}
const isWithinStartEndRange = (start, end, date)=>(0, _isSameMonth.default)(start, date) && (0, _isSameYear.default)(start, date) || (0, _isSameMonth.default)(end, date) && (0, _isSameYear.default)(end, date);
